// import { Currencies } from '@orbitalgaming/games-frontend-library'
import { Currencies } from '../../../helpers/currency/getCurrencySymbol'
import React, { useEffect, useState } from 'react'
import floorFigure from '../../configs/helpers/floorFigure'
import { BOARD_PROPS, SCORE_PROPS } from '../interface'
import {
  ContentWrapper,
  Content,
  Title,
  Result,
  Separator,
} from './ContentStyles'

function Scores({
  rollUnder,
  roll,
  result,
  profit,
  currency,
  lastResult,
  lastProfit,
  betId,
  win,
}: SCORE_PROPS) {
  const [value, setValue] = useState<string>(roll ? roll : '50.00')
  const [res, setres] = useState<boolean>(false)
  const [score, setscore] = useState<string>('--.--')

  const [prof, setprof] = useState<number>(0)
  const [load, setLoad] = useState<boolean>(true)

  useEffect(() => {
    if (load) {
      lastResult !== '' && setscore((+lastResult / 100).toFixed())
      setres(true)
      setprof(lastProfit)
    }
  }, [lastResult, lastProfit, load])

  useEffect(() => {
    if (betId !== '') {
      setLoad(false)
    }
  }, [betId])

  useEffect(() => {
    setprof(profit)
  }, [profit])

  useEffect(() => {
    result && (setscore((+result).toFixed(2)), setres(true))
  }, [result])

  useEffect(() => {
    if (roll) {
      setValue((+roll).toFixed(2))
    }
  }, [roll])

  return (
    <>
      <ContentWrapper>
        <Content>
          <Title> Roll {rollUnder ? 'Over' : 'Under'}</Title>
          <Result rollUnder={rollUnder} className='roll'>
            {(+value).toFixed(2)}
          </Result>
        </Content>
        <Separator />
        <Content>
          <Title win={prof > 0}>
            {prof > 0
              ? `win ${Currencies[currency ? currency : ''].symbol}${win}`
              : 'Cyberscore'}
          </Title>
          <Result res={!res} win={prof > 0}>
            {score}
          </Result>
        </Content>
      </ContentWrapper>
    </>
  )
}

export default Scores
